import Outline from '@heroicons/react/24/outline/AdjustmentsHorizontalIcon'
import Solid from '@heroicons/react/24/solid/AdjustmentsHorizontalIcon'
import { forwardRef } from 'react'
import HeroIcon, { HeroIconProps } from '../HeroIcon'

export default forwardRef<SVGSVGElement, HeroIconProps>((props, ref) => {
  const { type = 'solid', ...rest } = props
  return <HeroIcon ref={ref} Component={type === 'solid' ? Solid : Outline} {...rest} />
})
